import React from "react";
import { TextField, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const Root = styled('div')(({ theme }) => ({
  width: '100%',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  color: "#222",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#2ec4b6",
    },
    "&:hover fieldset": {
      borderColor: "#25a8a0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2ec4b6",
    },
    "&.Mui-error fieldset": {
      borderColor: "#e74c3c",
    },
    "& input": {
      color: "#222",
    },
  },
  margin: theme.spacing(3),
}));

const AnswerTextField = ({
  value,
  disabled = false,
  label,
  onChange,
  onKeyDown,
  number = false,
  inputComponent = "input",
  ...others
}) => {
  return (
    <Root>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <StyledTextField
            {...others}
            id="answer-text-field"
            style={{ margin: 8 }}
            label={label}
            value={value}
            fullWidth
            disabled={disabled}
            type={number ? "number" : "text"}
            InputProps={{
              readOnly: disabled,
              inputComponent: inputComponent,
              inputMode: "numeric",
            }}
            margin="normal"
            slotProps={{
              inputLabel: {
                shrink: true,
                sx: { color: '#2ec4b6' },
              },
              // Trivia answers are mostly proper nouns — iOS autocorrect mangles
              // them, and the autocorrect-pending state intercepts taps on the
              // Submit button. Turn it off, and surface a prominent "Send" key
              // in the keyboard so the existing Enter handler can submit.
              htmlInput: {
                autoComplete: "off",
                autoCorrect: "off",
                autoCapitalize: "off",
                spellCheck: false,
                enterKeyHint: "submit",
              },
            }}
            variant="outlined"
            onChange={onChange}
            onKeyDown={onKeyDown}
          />
        </Grid>
      </Grid>
    </Root>
  );
};

export default AnswerTextField;
